import React, { useState, useEffect, useContext } from "react";
import MenuScreen from "./MenuScreen";
import LoaderScreen from "./LoaderScreen";
import ErrorScreen from "./ErrorScreen";
// import NoWatchlistFoundIcon from "../assets/NoSearchResultFound1.png";
import NoWatchlistFoundIcon from "../assets/No_List_Found.png";
import MarkupGrid from "./MarkupGrid";
import { fetchContent } from "../services/api";
import ModalScreen from "./ModalScreen";
import DetailsScreen from "../Module/GallaryDetail/GallaryDetailScreen";
import { Translate } from "./LanguageChanger";
import loginimg from "../assets/loginimg.png";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import logoutIcon from "../assets/Logout-Icon.png";
import { getWatchList, logoutUser } from "../services/services";
import { useDebounce } from "../utils/useDebounce";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
import { AppContext } from "../AppContext";
import AuthFailModal from "./AuthFailModal";
import HomeDetailsScreen from "../Module/VodDetails/VodDetailScreen";
import GallaryDetailsScreen from "../Module/GallaryDetail/GallaryDetailScreen";

let resolution = window.RESOLUTION;
let shoudRefresh;

const WatchlistScreen = ({ navigate, isLogedIn }) => {
  const [state, setState] = useState({
    isLogedInUser: isLogedIn,
    loading: false,
    watchlistItems: [],
    shouldFocusToGrid: false,
    griddata: null,
    shouldCloseMenu: true,
    shouldShowError: false,
    shouldShowAuthModal: false,
    shouldRender: false,
    bgColor: "transparent",
    shouldShowModal: false,
    errTitle: "",
    errDescription: "",
    errIcon: "",
    button: ["Logout", "Cancel"],
    iconWdth: "",
    iconHeight: "",
  });
  const {
    isLogedInUser,
    loading,
    watchlistItems,
    shouldFocusToGrid,
    shouldCloseMenu,
    shouldShowError,
    shouldShowAuthModal,
    shouldRender,
    bgColor,
    griddata,
    shouldShowModal,
    errTitle,
    errDescription,
    errIcon,
    button,
    iconWdth,
    iconHeight,
  } = state;
  const [screen, setScreen] = useState();
  const [data, setData] = useState({});
  const [pageNumber, setPageNumber] = useState(1);
  const debouncedPageNumber = useDebounce(pageNumber, 500);
  const { sourceContext, setSourceContext } = useContext(AppContext);

  useEffect(() => {
    setSourceContext("Watchlist");
  
    // Matomo Event
    sendTestMatomoEvent({
      eventCategory: "Page",
      eventAction: "View",
      eventName: "Watchlist",
      url: `watchlist`,
    });

    sendTestMatomoEvent({ eventCategory: `Watchlist`, eventAction: "List" });
  }, []);

  const navigateToScreen = (screen, data = {}) => {
    setScreen(screen);
    setData(data);
  };
  const handleRightButton = () => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToGrid: true,
      shouldCloseMenu: true,
    }));
    MenuScreen.SetFocus(true);
  };
  const handleMenuselection = (selectedMenu) => {
    switch (selectedMenu) {
      case "Login":
        navigate("LoginScreen");
        break;
      case "Profile":
        navigate("ProfileScreen");
        break;
      case "Search":
        navigate("SearchScreen");
        break;
      case "Live":
        navigate("LiveScreen");
        break;
      case "LiveEvents":
        navigate("LiveEventsScreen");
        break;
      case "Home":
        navigate("HomePage");
        break;
      case "Watchlist":
        break;
      case "Categories":
        navigate("CategoryScreen");
        break;
      case "Settings":
        navigate("SettingsScreen");
        break;
      case "Logout":
        break;
      default:
        break;
    }
  };
  let hasFetchedData = false;
  let isGridCalled = true;
  let headers = {};

  // const loadData = async () => {
  //   console.log("watchlist....");
  //   if (hasFetchedData) return;
  //   hasFetchedData = true;
  //   if (!isGridCalled) return;
  //   if (
  //     localStorage.getItem("user_details") !== undefined &&
  //     localStorage.getItem("user_details") !== null
  //   ) {
  //     let user_details = JSON.parse(localStorage.getItem("user_details"));
  //     headers = {
  //       page:"1",
  //       lastupdated:"0000000000",
  //       Langid: "1",
  //       profileid: user_details.user_profiles[0].profile_id,
  //       "Authorization": `Bearer ${localStorage.getItem("JWTToken")}`,
  //       "Content-Type": "application/json",
  //       // profileid: user_details.user_profiles[0].profile_id,
  //       // Authorization: "Bearer " + localStorage.getItem("JWTToken"),
  //     };
  //   }
  //   try {
  //     const [fetchedWatchedList] = await Promise.all([
  //       fetchContent(
  //         "/V1/getWatchList/lastupdated/00000000000/page/1",
  //         "GET",
  //         headers
  //       ),
  //     ]);

  //     console.log("fetchedWatchedList.data --- = ", fetchedWatchedList, fetchedWatchedList.data.filter(data => data.is_deleted !== 1), shouldShowError);

  //     isGridCalled = false;
  //     setState((prevState) => ({
  //       ...prevState,
  //       loading: false,
  //       bgColor: "#000000",
  //       shouldFocusToGrid: true,
  //       shouldShowError: false,
  //       // watchlistItems:fetchedWatchedList.data,
  //       watchlistItems:(fetchedWatchedList.data.filter(data => data.is_deleted !== 1)),
  //     }));
  //     if(watchlistItems.length === 0){
  //       setState((prevState) => ({
  //         ...prevState,
  //         loading: false,
  //         shouldFocusToGrid: false,
  //         shouldShowError: true,
  //         shouldCloseMenu: false,
  //       }));
  //       MenuScreen.SetFocus(false);
  //       isGridCalled = false;
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     setState((prevState) => ({
  //       ...prevState,
  //       loading: false,
  //       shouldFocusToGrid: false,
  //       shouldShowError: true,
  //       shouldCloseMenu: false,
  //     }));
  //     MenuScreen.SetFocus(false);
  //     isGridCalled = false;
  //   }
  // };

  const handleAuthFailLogout = (p) => {
    console.log("handleAuthFailLogout......");
    setState((prevState) => ({
      ...prevState,
      shouldFocusToGrid: false,
      shouldCloseMenu: true,
      shouldShowModal: false,
      shouldShowAuthModal: true,
      shouldAddEventListener: false,
      // errTitle: "Session-Expired",
      errDescription: "session-desc",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Login"],
    }));
    MenuScreen.SetFocus(true);
  };

  const loadData = async () => {
     setState((prevState) => ({
        ...prevState,
        loading: true,
      }));
    if (hasFetchedData) return;
    hasFetchedData = true;
    if (!isGridCalled) return;

    const userId = localStorage.getItem("profileId");

    if (
      localStorage.getItem("user_details") !== undefined &&
      localStorage.getItem("user_details") !== null
    ) {
      let user_details = JSON.parse(localStorage.getItem("user_details"));
      headers = {
        page: "1",
        // lastupdated: "0000000000",
        // Langid: "1",
        profileid: user_details.user_profiles[0].profile_id,
        // Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
        // "Content-Type": "application/json",
      };
    }

    try {
      // const [response1, response2, response3, response4, response5] = await Promise.all([
      //   fetchContent(`/V1/getWatchList/lastupdated/00000000000/page/1/userId/${userId}`, "GET", headers),
      //   fetchContent(`/V1/getWatchList/lastupdated/00000000000/page/2/userId/${userId}`, "GET", headers),
      //   fetchContent(`/V1/getWatchList/lastupdated/00000000000/page/3/userId/${userId}`, "GET", headers),
      //   fetchContent(`/V1/getWatchList/lastupdated/00000000000/page/4/userId/${userId}`, "GET", headers),
      //   fetchContent(`/V1/getWatchList/lastupdated/00000000000/page/5/userId/${userId}`, "GET", headers),
      // ]);

      // const [response1, response2, response3, response4, response5] = await [
      //  getWatchList(userId,1)
      //  getWatchList(userId,2)
      //  getWatchList(userId,3)
      //  getWatchList(userId,4)
      //  getWatchList(userId,5)
      // ];

      const response1 = await getWatchList(userId, 1, headers);
      // const response2 = await getWatchList(userId, 2);
      // const response3 = await getWatchList(userId, 3);
      // const response4 = await getWatchList(userId, 4);
      // const response5 = await getWatchList(userId, 5);

      const fetchedWatchedList = {
        response1,
        // response2,
        // response3,
        // response4,
        // response5,
      };

      // Combine all data arrays from each response
      const allWatchedListData = [
        ...fetchedWatchedList.response1.data,
        // ...fetchedWatchedList.response2.data,
        // ...fetchedWatchedList.response3.data,
        // ...fetchedWatchedList.response4.data,
        // ...fetchedWatchedList.response5.data,
      ];

      // Filter the combined list where is_deleted !== 1
      const filteredWatchlist = allWatchedListData.filter(
        (data) => data.is_deleted !== 1
      );
      // const [fetchedWatchedList] = await Promise.all([
      //   fetchContent(
      //     "/V1/getWatchList/lastupdated/00000000000/page/1",
      //     "GET",
      //     headers
      //   ),
      // ]);

      // const filteredWatchlist = fetchedWatchedList.data.filter(
      //   (data) => data.is_deleted !== 1
      // );

      isGridCalled = false;

      if (filteredWatchlist.length === 0) {
        // No items in the watchlist, show error and prevent focus movement
        setState((prevState) => ({
          ...prevState,
          loading: false,
          watchlistItems: [],
          shouldFocusToGrid: false,
          shouldShowError: true,
          shouldCloseMenu: false,
        }));
        MenuScreen.SetFocus(true); // Prevent focus from moving
        isGridCalled = true;
      } else {
        // console.log("after add/remove..");
        // Watchlist has items, proceed as normal
        setState((prevState) => ({
          ...prevState,
          loading: false,
          bgColor: "#000000",
          shouldFocusToGrid: true,
          shouldShowError: false,
          watchlistItems: filteredWatchlist,
        }));
        // console.log(watchlistItems, filteredWatchlist);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      handleAuthFailLogout();
      setState((prevState) => ({
        ...prevState,
        loading: false,
        shouldFocusToGrid: false,
        shouldShowError: true,
        shouldShowAuthModal: true,
        shouldCloseMenu: false,
      }));
      MenuScreen.SetFocus(true); // Prevent focus from moving in case of an error
      isGridCalled = false;
    }
  };

  useEffect(() => {
    if (pageNumber > 5) {
      let isCancelled = false;
      let headers = {};

      const fetchData = async () => {
        if (hasFetchedData || !isGridCalled) return;
        hasFetchedData = true;

        const userId = localStorage.getItem("profileId");
        const userDetailsRaw = localStorage.getItem("user_details");

        if (userDetailsRaw) {
          const user_details = JSON.parse(userDetailsRaw);
          headers = {
            page: "1",
            lastupdated: "0000000000",
            Langid: "1",
            profileid: user_details.user_profiles[0].profile_id,
            Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
            "Content-Type": "application/json",
          };
        }

        try {
          const response1 = await getWatchList(userId, 1, headers);
          // const response1 = await fetchContent(
          //   `/V1/getWatchList/lastupdated/00000000000/page/${pageNumber}/userId/${userId}`,
          //   "GET",
          //   headers
          // );

          const allWatchedListData = [...response1.data];
          const filteredWatchlist = allWatchedListData.filter(
            (data) => data.is_deleted !== 1
          );
          isGridCalled = false;

          if (isCancelled) return;

          if (filteredWatchlist.length > 0) {
            setState((prev) => ({
              ...prev,
              loading: false,
              bgColor: "#000000",
              shouldFocusToGrid: true,
              shouldShowError: false,
              watchlistItems: [...watchlistItems, ...filteredWatchlist],
            }));
          } else {
            setPageNumber(1);
            return;
          }
        } catch (error) {
          console.error("Error fetching data:", error);
          if (!isCancelled) {
            setState((prev) => ({
              ...prev,
              loading: false,
              shouldFocusToGrid: false,
              shouldShowError: true,
              shouldCloseMenu: false,
            }));
            MenuScreen.SetFocus(false);
          }
          isGridCalled = false;
        }
      };

      fetchData();

      return () => {
        isCancelled = true; // cancel async if component unmounts
      };
    }
  }, [debouncedPageNumber]);

  const handleItemSelected = (item) => {
    console.log("checkingItems1",item)
    setSourceContext(`${sourceContext}`);
    let genres = item?.genres ?? item?.genre_titles;
    let actionName = `${item?.show_id}/${item?.title} - ${genres}`;
    const ciValue = `Watchlist/ContentSelected`;
 const VOD=item?.type==0
    const AOD=item?.type === 1 || item?.media_type === 1

const GallaryDetailsScreen=item?.type===4 ||item?.type===5||item?.type==6||item?.type===7
console.log("text",AOD)
   
       if(GallaryDetailsScreen){
          navigateToScreen("GallaryDetailsScreen",item)
          return ;
        }
    

          if(VOD||AOD)
        { 
          console.log("text1",VOD)
          navigateToScreen("HomeDetailsScreen", item)
          return ;
        }




 
    // Event
    sendTestMatomoEvent({
      eventCategory: "Watchlist",
      eventAction: "ContentSelected",
      eventName: `${item?.show_id}/${item?.title}`,
    });

    // Interaction
    sendTestMatomoEvent(
      { action_name: actionName },
      { eventType: "content_interaction",
        c_i:ciValue
      }
    );

    // Impression
    sendTestMatomoEvent(
      {
        action_name: actionName,
      },
      {
        eventType: "content_impression",
      }
    );
  };

  const callBack = () => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToGrid: false,
      shouldCloseMenu: false,
    }));
    MenuScreen.SetFocus(false);
  };

  const handleBack = (screenName) => {
    console.log("handleBack.....");
    setSourceContext("Watchlist");
    setTimeout(function () {
      loadData();
    }, 100);
    setState((prevState) => ({
      ...prevState,
      loading: false,
      shouldFocusToGrid: true,
      shouldCloseMenu: true,
    }));
    setScreen(screenName);
  };

  const modalOKButtonHandler = (action) => {
    switch (action) {
      case "Login":
        navigate("LoginScreen");
        sendTestMatomoEvent({
          eventCategory: "Page",
          eventAction: "View",
          eventName: "LoginPopup",
        });
        break;
      case "Logout":
        console.log("Logout....");
        logoutUser();
        localStorage.removeItem("JWTToken");
        localStorage.removeItem("userInfo");
        const getCountry = localStorage.getItem("country");
        let headers = {
          iskid: "0",
          Langid: "1",
          "Content-Type": "application/json",
          country: getCountry,
        };
        //Promise.all([fetchContent("/V1/logout", "POST", headers)]);
        MenuScreen.ReseTfocus(4);
        MenuScreen.SetFocus(true);
        handleMenuselection("Login");
        break;
      case "Yes":
        console.log("exit application..");
        exitApplication();
        // window.close();
        break;
      default:
        break;
    }
  };

  const exitApplication = () => {
    if (window.tizen) {
      sendTestMatomoEvent({ eventCategory: `App`, eventAction: "End" });
      window.tizen.application.getCurrentApplication().exit();
    } else {
      sendTestMatomoEvent({ eventCategory: `App`, eventAction: "End" });
      window.close();
    }
  };

  const handleLogout = (p) => {
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Logout",
      errDescription: "cofirm-logout",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Logout", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  };

  const handleLogin = (p) => {
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Login to Continue",
      errDescription: "LoginContinue",
      errIcon: loginimg,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Login", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  };

  const handleExit = () => {
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Exit",
      errDescription: "ExitMsg",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Yes", "No"],
    }));
    MenuScreen.SetFocus(true);
  };

  const modalCANCELButtonHandler = () => {
    MenuScreen.ReseTfocus(6);
    // MenuScreen.ReseTfocus(-1);
    setState((prevState) => ({
      ...prevState,
      shouldFocusToGrid: true,
      shouldShowModal: false,
      shouldCloseMenu: false,
    }));
    // MenuScreen.SetFocus(false);

    // Matomo Event
    sendTestMatomoEvent({
      eventCategory: "Page",
      eventAction: "View",
      eventName: "CancelPopup",
    });
  };

  shoudRefresh = () => {
    setState((prevState) => ({
      ...prevState,
      shouldRender: true,
    }));
  };

  const detailToDetail = (recommendationItem) => {
    console.log("naveen :: detailToDetail", recommendationItem);
    // setData(recommendationItem);
    // setScreen("DetailsScreen")
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));
     const VOD = recommendationItem?.type == 0
    const AOD = recommendationItem?.type === 1 || recommendationItem?.media_type === 1
    const AudioLiveTv = recommendationItem?.type == 1 && recommendationItem?.still_live == 1
    const LiveTV = recommendationItem.type === 0 && recommendationItem.still_live === 1;
    const LiveEvent = recommendationItem.type === 9  //review from other all checks below logic
    const GallaryDetailsScreen = recommendationItem?.type === 4 || recommendationItem?.type === 5 || recommendationItem?.type == 6 || recommendationItem?.type === 7
    navigateToScreen("", recommendationItem);
    setTimeout(function () {
      setState((prevState) => ({
        ...prevState,
        loading: false,
      }));

      console.log("textjjjj", AOD)

      if (GallaryDetailsScreen) {
        navigateToScreen("GallaryDetailsScreen", recommendationItem)
        return;
      }
     
      if (VOD || AOD) {
        console.log("text1", VOD)
        navigateToScreen("HomeDetailsScreen", recommendationItem)
        return;
      }
    }, 100);
  };

  // Add key event handler for Case 37 and Backspace
  useEffect(() => {
    const handleKeyDown = (event) => {
      const keyCode = event.keyCode;
      
      // Case 37: Left arrow key OR Case 8: Backspace - Open menu when watchlist is empty
      if ((keyCode === 37 || keyCode === 8) && shouldShowError && !shouldCloseMenu) {
        setState((prevState) => ({
          ...prevState,
          shouldCloseMenu: true,
        }));
        MenuScreen.SetFocus(false);
      }
    
     if ((keyCode === 39 ) && shouldShowError && !shouldCloseMenu) {
        setState((prevState) => ({
          ...prevState,
          shouldCloseMenu: false,
        }));
        MenuScreen.SetFocus(true);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [shouldShowError, shouldCloseMenu]);

  useEffect(() => {
    // console.log("1111111111...");
    if (isLogedInUser) {
      loadData();
    } else {
      // console.log("2222222222....");
      setState((prevState) => ({
        ...prevState,
        shouldShowError: true,
        shouldCloseMenu: false,
      }));
      MenuScreen.SetFocus(false);
    }
    return () => {
      // console.log("watchlistScreen...");
    };
    // setState((prevState) => ({
    //   ...prevState,
    //   shouldFocusToGrid: false,
    //   shouldCloseMenu: false,
    //   }));
    // MenuScreen.SetFocus(false);
  }, []);


    if (screen === "HomeDetailsScreen") {
    console.log("hooo")
    return (
      <HomeDetailsScreen
       handleBack={handleBack}
          isLogedIn={isLogedIn}
          navigate={navigate}
          data={data}
          detailToDetail={detailToDetail}
      />
    );
    
  }
   else if (screen === "GallaryDetailsScreen") {
    console.log("hooo")
    return (
      <GallaryDetailsScreen
         handleBack={handleBack}
          isLogedIn={isLogedIn}
          navigate={navigate}
          data={data}
          detailToDetail={detailToDetail}
      />
    );
    
  }else {
      return (
      <div style={styles.WatchlistScreenContainer}>
        {loading && <LoaderScreen />}

        <div style={styles.header}>
          <Translate langKey={"Watchlist"} />
        </div>
        <div style={styles.contentArea}>
          <MarkupGrid
            items={watchlistItems}
            onItemSelected={handleItemSelected}
            rowWidth="100%"
            rowHeight={300}
            columnWidth={resolution === "FHD" ? 215 : 143}
            columnHeight={resolution === "FHD" ? 276 : 184}
            itemWidth={resolution === "FHD" ? 215 : 143}
            itemHeight={resolution === "FHD" ? 276 : 184}
            numberOfColumnsEachRow={7}
            numberOfDefaultRows={3}
            selectionColor={shouldFocusToGrid ? "#fff" : "transparent"}
            selectionStyle="border"
            gapBetweenColumns={20}
            gapBetweenRows={resolution === "FHD" ? 10 : 7}
            columnBgColorOrImage="#0000"
            rowBgColorOrImage="#0000"
            shouldScrollHorizontally={false}
            shouldScrollVertically={true}
            scrollDuration={300}
            GridXCordinate={0}
            GridYCordinate={0}
            shouldFocus={shouldFocusToGrid}
            callBack={callBack}
            itemComponentName="SearchWidget"
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
          />
        </div>
        <MenuScreen
          navigate={navigateToScreen}
          handleMenuselection={handleMenuselection}
          shouldCloseMenu={shouldCloseMenu}
          handleRightButton={handleRightButton}
          isLogedIn={isLogedIn}
          appNavigate={navigate}
          handleLogin={handleLogin}
          handleLogout={handleLogout}
          handleExit={handleExit}
        />
        <ErrorScreen
          disply={shouldShowError ? "flex" : "none"}
          errorIcon={NoWatchlistFoundIcon}
          bgcolor=""
          watchList ={true}
        />
        <ModalScreen
          shouldShowError={shouldShowModal}
          errTitle={errTitle}
          errDescription={errDescription}
          errIcon={errIcon}
          button={button}
          iconWdth={iconWdth}
          iconHeight={iconHeight}
          modalOKButtonHandler={modalOKButtonHandler}
          modalCANCELButtonHandler={modalCANCELButtonHandler}
        />
        <div
          style={{
            position: "absolute",
          }}
        >
          <AuthFailModal
            shouldShowError={shouldShowAuthModal}
            errTitle={errTitle}
            errDescription={errDescription}
            errIcon={errIcon}
            button={button}
            iconWdth={iconWdth}
            iconHeight={iconHeight}
            modalOKButtonHandler={modalOKButtonHandler}
            modalCANCELButtonHandler={modalCANCELButtonHandler}
          />
        </div>
      </div>
    );
  }
};

const styles = {
  WatchlistScreenContainer: {
    display: "flex",
    flexDirection: "column",
    background: `url(${solidbackgroundimg})`,
    // background: "#000037",
    width: "100vw",
    height: "100vh",
    backgroundSize: "cover",
    backgroundPosition: "center", // Center the background image
    backgroundRepeat: "no-repeat", // Do not repeat the background image
    color: "#D0D0D0",
    fontSize: "18px",
    overflow: "hidden",
  },
  header: {
    display: "column",
    width: "95%",
    overflow: "hidden",
    marginLeft: "78px",
    alignItems: "center",
    textAlign: "center",
    fontSize: "40px",
    color: "#FFFFFF",
    background: "transparent",
    position: "absolute",
    paddingTop: "38px",
  },
  contentArea: {
    display: "flex",
    flexDirection: "column",
    height: "945px",
    width: "90vw",
    marginLeft: "148px",
    marginTop: "120px",
    background: "transparent",
    position: "absolute",
  },
};

WatchlistScreen.Refresh = (focusedIndx) => {
  shoudRefresh(true);
};

export default WatchlistScreen;